import { lazy } from 'react';
import { LandingPageSetting } from '../shared/API/clubs/club.interface';
import { RouteData } from './route.interface';

const Home = lazy(() => import('../pages/Home'));
const Login = lazy(() => import('../pages/Login'));
const Awards = lazy(() => import('../pages/Awards'));
const AdheredBusinesses = lazy(() => import('../pages/AdheredBusinesses/List'));
const ShowAward = lazy(() => import('../pages/Awards/Show'));
const Discounts = lazy(() => import('../pages/Discounts'));
const ShowDiscount = lazy(() => import('../pages/Discounts/Show'));
const Terms = lazy(() => import('../pages/Terms'));
const Register = lazy(() => import('../pages/Register'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const Profile = lazy(() => import('../pages/Profile'));
const MyCard = lazy(() => import('../pages/MyCard'));
const MyCredits = lazy(() => import('../pages/MyCredits'));
const MyCoupons = lazy(() => import('../pages/MyCoupons'));
const MyVouchers = lazy(() => import('../pages/MyVouchers'));
const MyGifcards = lazy(() => import('../pages/MyGiftcards'));
const MyReports = lazy(() => import('../pages/MyReports'));
const UseCoupon = lazy(() => import('../pages/UseCoupon'));
const Roulette = lazy(() => import('../pages/Roulette'));

export const buildRoutes = (landingPageSetting: LandingPageSetting): RouteData => {
  const routes: RouteData = {
    menu: [
      {
        label: 'Home',
        path: '/',
        exact: true,
        component: Home,
      },
      {
        path: '/terms',
        exact: true,
        component: Terms,
      },
      {
        path: '/forgot-password',
        exact: true,
        component: ForgotPassword,
      },
      {
        path: '/profile',
        exact: true,
        component: Profile,
      },
      {
        path: '/my-activity',
        exact: true,
        component: MyReports,
      },
      {
        path: '/my-credits',
        exact: true,
        component: MyCredits,
      },
    ],
  };

  if (landingPageSetting.module_coupons_active) {
    routes.menu.push(
      {
        path: '/use/coupon/:token',
        exact: true,
        component: UseCoupon,
      },
      {
        label: 'Descuentos',
        path: '/discounts',
        exact: true,
        component: Discounts,
      },
      {
        path: '/discounts/:discountId',
        exact: true,
        component: ShowDiscount,
      },
    );
  }

  if (landingPageSetting.module_awards_active) {
    routes.menu.push(
      {
        label: 'Premios',
        path: '/awards',
        exact: true,
        component: Awards,
      },
      {
        path: '/awards/:awardId',
        exact: true,
        component: ShowAward,
      },
    );
  }

  if (landingPageSetting.module_adhered_businesses_active) {
    routes.menu.push(
      {
        path: '/adheredBusinesses',
        exact: true,
        component: AdheredBusinesses,
      },
      {
        path: '/adheredBusiness/:adheredBusinessUrl',
        exact: true,
        component: Home,
      },
      {
        path: '/adheredBusiness/:adheredBusinessUrl/awards',
        exact: true,
        component: Awards,
      },
      {
        path: '/adheredBusiness/:adheredBusinessUrl/discounts',
        exact: true,
        component: Discounts,
      },
    );
  }

  if (landingPageSetting.module_register_active) {
    routes.menu.push({
      label: 'Registrarse',
      path: '/register',
      exact: true,
      component: Register,
    });
  }

  if (landingPageSetting.module_login_active) {
    routes.menu.push({
      path: '/login',
      exact: true,
      component: Login,
    });
  }

  if (landingPageSetting.module_my_card) {
    routes.menu.push({
      path: '/my-card',
      exact: true,
      component: MyCard,
    });
  }

  if (landingPageSetting.module_my_coupons) {
    routes.menu.push({
      path: '/my-coupons',
      exact: true,
      component: MyCoupons,
    });
  }

  if (landingPageSetting.module_my_vouchers) {
    routes.menu.push({
      path: '/my-vouchers',
      exact: true,
      component: MyVouchers,
    });
  }

  if (landingPageSetting.module_my_giftcards) {
    routes.menu.push({
      path: '/my-giftcards',
      exact: true,
      component: MyGifcards,
    });
  }

  if (landingPageSetting.module_rulette_game) {
    routes.menu.push({
      path: '/game',
      exact: true,
      component: Roulette,
    });
  }

  return routes;
};

export const clubsWithoutRegister = ['stephanie-demner', 'empire-padel'];
export const clubsWithoutGame = ['telavendo'];
export const clubsWithoutGiftcard = ['telavendo'];
export const clubsWithoutExchangePointsByMoney = ['los-novillo'];
export const clubsWithoutExchangeGameCoinsByMoney = ['los-novillo'];
